import React from 'react';

import reportPageEmptyState from 'styles/assets/svg/reportPageEmptyState.svg';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/pages/ScheduleViewsPage/components/EmptyState/EmptyState.module.scss';

interface Props {
    onAddView: () => void;
}

export const EmptyState = ({ onAddView }: Props) => {
    return (
        <div className={classes.emptyStateWrapper}>
            <div className={classes.emptyState}>
                <img src={reportPageEmptyState} className={classes.emptyStateImage} alt={'empty state image'} />
                <div className={classes.emptyStateTitle}>Welcome to your schedule views</div>
                <div className={classes.emptyStateSubTitle}>
                    Start by creating a view to organize and visualize your schedule. Views help you manage timelines,
                    tasks, and key milestones.
                </div>
                <div className={classes.buttonWrapper}>
                    <Button
                        onClick={onAddView}
                        startIcon={<MuiIcon icon={'add'} color={'inherit'} />}
                        data-testid={'add-view-btn'}
                    >
                        Create view
                    </Button>
                </div>
            </div>
        </div>
    );
};
